const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/LogoutBtn.tsx';
import { useDispatch } from 'react-redux';
import { logout } from 'App/actions/fixme.login';
import * as React from 'react';
import { IconBtn } from '../AppBar/IconBtn';

export const LogoutBtn = () => {
    const dispatch = useDispatch();

    const btnClicked = () => {
        dispatch((logout as any)());
    };

    return <IconBtn kind={'logout'} onClick={btnClicked} marginRight={16} />;
};
